import {
  PAGESIZE_ALL,
  TYPE_GLOBAL_PROPOTIES_BANK,
  TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
  TYPE_GLOBAL_PROPOTIES_POS_LIST,
  TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
} from "app/common/LocalConst";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingExtGlobalProperty } from "app/services/GlobalPropertyService";
import { exportSummaryOrderReport } from "app/services/InvoiceItemService";
import { pagingCancelInvoiceReport } from "app/services/ReportService";
import {
  getVoucherCancelById,
  pagingVoucherHistory,
} from "app/services/VoucherService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ReportCancelInvoiceStore {
  listDataReportCancelInvoice = null;
  searchReportCancelInvoice = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    listDepId: null,
  };

  listStk = [];
  listPos = [];
  listPos_tragop = [];
  listHomecredit = [];
  dataInvoicePopupFee = null;
  editableVoucher = false;
  openVoucherPopupDetail = false;
  dataVoucherPopupReportCancelInvoice = null;
  openHistoryFeePopup = false;
  searchDataHistory = null;
  pageDataHistory = new PageResponse();
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchReportCancelInvoice = (searchReportCancelInvoice) => {
    this.searchReportCancelInvoice = {
      ...this.searchReportCancelInvoice,
      ...searchReportCancelInvoice,
    };
    this.pagingReportCancelInvoice();
  };

  pagingReportCancelInvoice = async () => {
    let { listDepId, serviceId, ...ortherData } =
      this.searchReportCancelInvoice;

    // Không call API nếu không có cơ sở (bắt buộc)
    if (!listDepId || listDepId.length === 0) {
      this.listDataReportCancelInvoice = null;
      return;
    }

    if (listDepId) {
      ortherData.listDepId = listDepId?.map((el) => el?.id);
    } else {
      ortherData.listDepId = null;
    }
    if (serviceId) {
      ortherData.serviceId = serviceId?.id;
    }
    return await pagingCancelInvoiceReport({ ...ortherData })
      .then(({ data }) => {
        this.listDataReportCancelInvoice = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hủy hóa đơn có lỗi");
      });
  };

  // handle call api get by id
  getDataDetailVoucherReportCancelInvoice = async (
    voucher,
    defaultDepartment
  ) => {
    const voucherId = voucher?.id;
    this.editableVoucher = false;
    this.openVoucherPopupDetail = true;
    if (!voucherId) {
      return;
    }

    try {
      const response = await getVoucherCancelById(voucherId);
      const data = response.data;
      let { voucherPaymentMethods } = data;
      let voucherPaymentMethodsFormat = await this.handleGetBankMethod(
        voucherPaymentMethods
      );

      this.dataVoucherPopupReportCancelInvoice = {
        ...data,
        voucherPaymentMethods: voucherPaymentMethodsFormat,
      };

      this.getListPropertiesReportCancelInvoice({
        departmentIds: defaultDepartment ? [defaultDepartment.id] : [],
      });
      this.openVoucherPopupDetail = true;
      console.log(data);
      return data; // ✅ Trả dữ liệu về nếu cần dùng tiếp
    } catch (error) {
      toast.error("Lấy chi tiết phiếu thu có lỗi");
      console.error(error);
      return null;
    }
  };

  handleGetBankMethod = async (voucherPaymentMethods) => {
    console.log("lotttt");
    if (voucherPaymentMethods?.length > 0) {
      const formatItems = await Promise.all(
        (voucherPaymentMethods || []).map(async (item) => {
          if (item?.bankAccountNumber) {
            let paymentBank = await pagingExtGlobalProperty({
              keyword: item?.bankAccountNumber,
              pageIndex: 1,
              pageSize: 1,
              isActive: true,
            });
            return {
              ...item,
              paymentBank: paymentBank?.data?.content?.[0],
            };
          } else {
            return item;
          }
        })
      );
      return formatItems;
    }
    return [];
  };

  getListPropertiesReportCancelInvoice = async (obj) => {
    return await pagingExtGlobalProperty({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      isActive: true,
      // dataType: TYPE_GLOBAL_PROPOTIES_BANK,
      ...obj,
    })
      .then(({ data }) => {
        if (data?.content?.length > 0) {
          const listStk = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_BANK
          );
          this.listStk = listStk;
          const listPos = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_POS_LIST
          );
          this.listPos = listPos;

          const listPos_tragop = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP
          );
          this.listPos_tragop = listPos_tragop;

          const listHomecredit = data?.content?.filter(
            (el) => el?.dataType === TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE
          );
          this.listHomecredit = listHomecredit;

          return {
            listStk,
            listPos,
            listHomecredit,
            listPos_tragop,
          };
        } else {
          return {
            listStk: [],
            listPos: [],
            listHomecredit: [],
            listPos_tragop: [],
          };
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
      });
  };

  // lịch sử
  handleChangeFormSearchHistory = (searchDataHistory) => {
    this.searchDataHistory = {
      ...this.searchDataHistory,
      ...searchDataHistory,
    };
    this.pagingHistory();
  };

  pagingHistory = async () => {
    return await pagingVoucherHistory({ ...this.searchDataHistory })
      .then(({ data }) => {
        this.pageDataHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử thanh toán có lỗi");
      });
  };

  handleOpenHistoryFeePopup = async (values) => {
    try {
      this.handleChangeFormSearchHistory(values);
      this.openHistoryFeePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleCloseHistoryFeePopup = async () => {
    this.openHistoryFeePopup = false;
    this.searchDataHistory = null;
  };

  handleExportReportInvoiceSummary = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = { ...this.normalizeSearchReportInvoiceSummary(searchObj) };
    try {
      const response = await exportSummaryOrderReport(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_DON_HANG_TONG_HOP_TRUOC.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  handleCloseServiceReportInvoiceSummary = () => {
    this.openInvoicePopup = false;
    this.openVoucherPopupDetail = false;
  };

  normalizeSearchReportInvoiceSummary = (rawSearch = {}) => {
    const { listDepId, ...rest } = rawSearch;
    return {
      ...rest,
      listDepId: listDepId?.map((el) => el?.id),
    };
  };
  resetStore = () => {
    this.listDataReportCancelInvoice = null;
    this.searchReportCancelInvoice = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      listDepId: null,
    };
  };

  resetStorePopup = () => {
    this.dataInvoicePopupFee = null;
    this.editableVoucher = false;
    this.listPos = [];
    this.listStk = [];
    this.listHomecredit = [];
    this.listPos_tragop = [];
  };
}
